import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'app-integridade-resultado-modal',
  templateUrl: './integridade-resultado-modal.component.html',
  styleUrls: ['./integridade-resultado-modal.component.scss']
})
export class IntegridadeResultadoModalComponent {
  constructor(
    public dialogRef: MatDialogRef<IntegridadeResultadoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  get temProblemas(): boolean {
    return (this.data.reenviados > 0 || this.data.falhas > 0 || this.data.pendentes > 0)
  }

  get reenviados(): any[] {
    return this.data.detalhes?.filter((d: any) => d.status === 'REENVIADO') || []
  }

  get falhas(): any[] {
    return this.data.detalhes?.filter((d: any) => d.status === 'FALHA') || []
  }

  get pendentesEnvio(): any[] {
    return this.data.detalhes?.filter((d: any) => d.status === 'PENDENTE_ENVIO') || []
  }

  fechar(): void {
    this.dialogRef.close()
  }
}
